export const DEFAULT_INVOICE_DATA = {
  tableHeaderColor: [43, 112, 115],
  tableHeaderTextColor: [255, 255, 255],
  headerColor: [0, 0, 0],
  header: "Quotation",
  headerDescription: "",
  invoiceNo: "",
  date: new Date().toISOString().split("T")[0],
  offerExpiry: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0],
  from: {
    name: "UP Business Hub, Inc.",
    address:
      "Suite 110, Centro Maximo Bldg., D. Jaokosalem St., Cebu City, Cebu 6000, Philippines",
    contact: "+63324076470 / +639954702897",
  },
  to: {
    salutation: "",
    name: "",
    address: "",
    email: "",
    contact: "",
    rep: "",
    tinNo: "",
  },
  cashDetails: "",
  checkDetails: "",
  gcashQr: null,
  gcashQr2: null,
  logo: null,
  items: [
    {
      description: "",
      quantity: 1,
      unitCost: "",
      discount: "",
      comment: "",
      subTotal: 0,
    },
  ],
  vatOption: "vat",
  vatMethod: "inclusive",
  taxCode: "",
  vatRate: 12,
  qrAlignment: {
    qr1: { scale: 1, offsetX: 0, offsetY: 0 },
    qr2: { scale: 1, offsetX: 0, offsetY: 0 },
    canvasWidth: 440,
    canvasHeight: 300,
    lastAligned: null,
  },
};

export const DEFAULT_CHARGES_DATA = {
  tableHeaderColor: [43, 112, 115],
  tableHeaderTextColor: [255, 255, 255],
  headerColor: [0, 0, 0],
  header: "Notice of Charges",
  headerDescription: "",
  invoiceNo: "",
  date: new Date().toISOString().split("T")[0],
  offerExpiry: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0],
  from: {
    name: "UP Business Hub, Inc.",
    address:
      "Suite 110, Centro Maximo Bldg., D. Jaokosalem St., Cebu City, Cebu 6000, Philippines",
    contact: "+63324076470 / +639954702897",
  },
  to: {
    salutation: "",
    name: "",
    address: "",
    email: "",
    contact: "",
    rep: "",
    tinNo: "",
  },
  cashDetails: "",
  checkDetails: "",
  gcashQr: null,
  gcashQr2: null,
  logo: null,
  items: [
    {
      item: "",
      price: 0,
    },
  ],
  vatOption: "vat",
  vatMethod: "exclusive",
  taxCode: "",
  vatRate: 12,
  qrAlignment: {
    qr1: { scale: 1, offsetX: 0, offsetY: 0 },
    qr2: { scale: 1, offsetX: 0, offsetY: 0 },
    canvasWidth: 440,
    canvasHeight: 300,
    lastAligned: null,
  },
};

export const ackTemplate = {
  header: "Acknowledgement",
  ackType: "acknowledgement",
  headerImage: null,
  date: new Date().toISOString().split("T")[0],
  notarizationStatus: "non-notarized",
  notarizationType: "",
  tableHeaderColor: [43, 112, 115],
  tableHeaderTextColor: [255, 255, 255],
  from: {
    name: "UP Business Hub, Inc.",
    address:
      "Suite 110, Centro Maximo Bldg., D. Jaokosalem St., Cebu City, Cebu 6000, Philippines",
    contact: "+63324076470 / +639954702897",
  },
  to: {
    salutation: "",
    name: "",
    address: "",
    contact: "",
    email: "",
    rep: "",
    tinNo: "",
  },
  items: [
    {
      document: "",
      description: "",
      copies: 0,
    },
  ],
  pdfUrl: "",
  body1: "",
  body2: "",
  subject: "",
  closing: {
    name: "",
    position: "",
    company: "",
    complimentary: "Respectfully,",
  },
};

export const transmittalTemplate = {
  header: "Transmittal Letter",
  headerImage: null,
  date: new Date().toISOString().split("T")[0],
  tableHeaderColor: [43, 112, 115],
  tableHeaderTextColor: [255, 255, 255],
  from: {
    name: "UP Business Hub, Inc.",
    address:
      "Suite 110, Centro Maximo Bldg., D. Jaokosalem St., Cebu City, Cebu 6000, Philippines",
    contact: "+63324076470 / +639954702897",
  },
  to: {
    salutation: "",
    name: "",
    address: "",
    email: "",
    contact: "",
    rep: "",
    tinNo: "",
  },
  items: [
    {
      item: "",
      price: 0,
    },
  ],
  pdfUrl: "",
  body1: "",
  body2: "",
  subject: "",
  closing: {
    name: "",
    position: "",
    company: "",
    complimentary: "Respectfully,",
  },
};

export const legalAdviceTemplate = {
  header: "Legal Advice",
  ackType: "legal",
  headerImage: null,
  date: new Date().toISOString().split("T")[0],
  notarizationStatus: "non-notarized",
  notarizationType: "",
  tableHeaderColor: [43, 112, 115],
  tableHeaderTextColor: [255, 255, 255],
  from: {
    name: "UP Business Hub, Inc.",
    address:
      "Suite 110, Centro Maximo Bldg., D. Jaokosalem St., Cebu City, Cebu 6000, Philippines",
    contact: "+63324076470 / +639954702897",
  },
  to: {
    salutation: "",
    name: "",
    address: "",
    contact: "",
    email: "",
    rep: "",
    tinNo: "",
  },
  items: [
    {
      document: "",
      description: "",
      copies: 0,
    },
  ],
  pdfUrl: "",
  body1: "",
  body2: "",
  subject: "",
  closing: {
    name: "",
    position: "",
    company: "",
    complimentary: "Respectfully,",
  },
};

export const secResTemplate = {
  header: "Secretarial Resolution",
  ackType: "secres",
  headerImage: null,
  date: new Date().toISOString().split("T")[0],
  notarizationStatus: "non-notarized",
  notarizationType: "",
  tableHeaderColor: [43, 112, 115],
  tableHeaderTextColor: [255, 255, 255],
  from: {
    name: "UP Business Hub, Inc.",
    address:
      "Suite 110, Centro Maximo Bldg., D. Jaokosalem St., Cebu City, Cebu 6000, Philippines",
    contact: "+63324076470 / +639954702897",
  },
  to: {
    salutation: "",
    name: "",
    address: "",
    contact: "",
    email: "",
    rep: "",
    tinNo: "",
  },
  items: [
    {
      document: "",
      description: "",
      copies: 0,
    },
  ],
  pdfUrl: "",
  body1: "",
  body2: "",
  subject: "",
  closing: {
    name: "",
    position: "",
    company: "",
    complimentary: "Respectfully,",
  },
};

export const juratTemplate = {
  notarization: {
    location: "Cebu City",
    date: new Date().toISOString().split("T")[0],
    affiants: [
      {
        name: "",
        label: "Affiant",
        validID: "",
        expiry: "",
        dateOrPlaceofIssuance: "",
      },
    ],
    notaryInfo: {
      docNo: "",
      pageNo: "",
      bookNo: "",
      series: "",
    },
    // Predefined text that remains constant
    notaryText: {
      nt1: "",
      nt2: "",
    },
  },
};

export const notarizationTemplate = {
  notarization: {
    location: "Cebu City",
    date: new Date().toISOString().split("T")[0],
    affiants: [
      {
        name: "",
        label: "Affiant",
        validIdType: "",
        validIdNo: "",
        expiry: "",
        dateOrPlaceofIssuance: "",
      },
    ],
    witnesses: [
      {
        name: "",
        label: "Witness",
      },
    ],
    notaryInfo: {
      docNo: "",
      pageNo: "",
      bookNo: "",
      series: "",
    },
    // Predefined text that remains constant
    notaryText: {
      nt1: "",
      nt2: "",
      nt3: "",
      nt4: "",
    },
  },
};

export const defaultMailBody = (invoice, invoiceType = "invoices") => {
  const customer = invoice.to?.name ? invoice.to.name : "Customer";
  const sender = invoice.from?.name || "UP Business Hub";

  let body;

  if (invoiceType === "invoices") {
    body = `Dear ${customer},\n\nI hope you are doing well.\n\nPlease find attached your invoice for the recent services rendered. Kindly review the invoice at your earliest convenience. If you have any questions or require further clarification regarding the details, please do not hesitate to contact us.\n\nWe appreciate your prompt attention to this matter and thank you for your continued business.\n\nBest regards,\n${sender}`;
  } else if (invoiceType === "noc") {
    body = `Dear ${customer},\n\nI hope you are doing well.\n\nPlease find attached the Notice of Charges for the recent services rendered. Kindly review the attached document at your earliest convenience. If you have any questions or require further clarification regarding the details, please do not hesitate to contact us.\n\nWe appreciate your prompt attention to this matter and thank you for your continued business.\n\nBest regards,\n${sender}`;
  } else if (invoiceType === "transmittal") {
    body = `Dear ${customer},\n\nI hope this message finds you well.\n\nAttached, please find the transmittal receipt for your recent transaction/s. Kindly review the transmittal and let us know if you have any questions or require further details.\n\nThank you for your cooperation and prompt attention.\n\nSincerely,\n${sender}`;
  } else if (invoiceType === "acknowledgement") {
    body = `Dear ${customer},\n\nGreetings!\n\nThis is to acknowledge receipt of your documents. Please find attached the acknowledgement receipt for your records. Should you have any questions or need additional support, please feel free to contact us.\n\nThank you for your prompt response.\n\nBest regards,\n${sender}`;
  } else if (!invoiceType) {
    body = `Dear ${customer},\n\nI hope you are doing well.\n\nPlease find attached your invoice for the recent services rendered. Kindly review the invoice at your earliest convenience. If you have any questions or require further clarification regarding the details, please do not hesitate to contact us.\n\nWe appreciate your prompt attention to this matter and thank you for your continued business.\n\nBest regards,\n${sender}`;
  }

  return body;
};

export const receiptsApps = [
  {
    key: "invoicesSubAccess",
    name: "Invoices",
    path: "/receipts/invoices",
    icon: "receipt_long",
    description: "Create and manage invoices",
    pageType: "invoice", // Add this
    disabled: false,
  },
  {
    key: "noticeChargesAccess",
    name: "Notice of Charges",
    path: "/receipts/noc",
    icon: "point_of_sale",
    description: "Handle charge notifications",
    pageType: "invoice", // Add this
    disabled: false,
  },
  {
    name: "Acknowledgement Receipts",
    key: "ackReceiptsAccess",
    path: "/receipts/acknowledgement",
    icon: "verified_user",
    description: "Generate acknowledgement receipts",
    pageType: "invoice", // Add this
    disabled: false,
  },
];

export const recordsApps = [
  {
    name: "Transmittal",
    key: "transmittalAccess",
    path: "/records/transmittal",
    icon: "article_shortcut",
    description: "External document transmittal",
    category: "External",
    pageType: "invoice",
    disabled: false,
  },
  {
    name: "Legal Advice",
    key: "legalAdviceAccess",
    path: "/records/legal-advice",
    icon: "balance",
    description: "External legal consultations",
    category: "External",
    pageType: "invoice",
    disabled: false,
  },
  {
    key: "secretariatResolutionsAccess",
    name: "Secretariat Resolutions",
    path: "/records/sec-res",
    icon: "domain",
    description: "Corporate secretary records",
    category: "External",
    pageType: "invoice",
    disabled: false,
  },
  {
    key: "caseBriefAccess",
    name: "Case Brief",
    path: "/records/case-brief",
    icon: "business_center",
    description: "Internal case documentation",
    category: "Internal",
    pageType: "logs",
    disabled: false,
  },
  {
    key: "executiveAdminAccess",
    name: "Executive & Administrative",
    path: "/records/exec-admin",
    icon: "admin_panel_settings",
    description: "Executive and Administrative logs",
    category: "Internal",
    pageType: "logs",
    disabled: false,
  },
  {
    name: "Secretarial Records",
    key: "secretarialLogsAccess",
    path: "/records/secretarial-records",
    icon: "contract_edit",
    description: "Secretary logs and activity tracking",
    category: "Internal",
    pageType: "logs",
    disabled: false,
  },
  {
    name: "Process Server & Messenger Logs",
    key: "processServerLogsAccess",
    path: "/records/process-server-logs",
    icon: "delivery_truck_speed",
    description: "Process server activities",
    category: "Internal",
    pageType: "logs",
    disabled: false,
  },
];

// Helper function to get page type from route params
export const getPageType = (group, type) => {
  const allApps = [...receiptsApps, ...recordsApps];
  const app = allApps.find((app) => {
    const pathParts = app.path.split("/");
    return pathParts[1] === group && pathParts[2] === type;
  });

  return app?.pageType || "invoice";
};

// Helper to get app config
export const getAppConfig = (group, type) => {
  const allApps = [...receiptsApps, ...recordsApps];
  return allApps.find((app) => {
    const pathParts = app.path.split("/");
    return pathParts[1] === group && pathParts[2] === type;
  });
};

export const selectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    boxShadow: "none",
    outline: "none",
    borderColor: state.isFocused ? "#4FD1C5" : "#E2E8F0",
    "&:hover": {
      borderColor: "#4FD1C5",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#ADADAD",
  }),
  input: (base) => ({
    ...base,
    color: "#fff",
  }),
  option: () => ({}),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#fff",
    cursor: "pointer",
    "&:hover": {
      color: "#fbbf24",
    },
  }),
};

export const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    borderColor: state.isFocused ? "#facc15" : "rgba(255, 255, 255, 0.2)",
    boxShadow: state.isFocused ? "0 0 0 2px #facc15" : "none",
    borderRadius: "0.75rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "0.25rem",
    paddingRight: "0.25rem",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#ffffff",
    transition: "all 0.2s ease-in-out",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#ffffff",
  }),
  placeholder: (base) => ({
    ...base,
    color: "rgba(255, 255, 255, 0.5)",
  }),
  input: (base) => ({
    ...base,
    color: "rgba(255, 255, 255, 0.8)",
  }),
};

export const getStatusBgColor = (status) => {
  const colors = {
    "In Progress": "#93c5fd", // blue-300
    "Not Started": "#9ca3af", // gray-400
    Interrupted: "#fde68a", // yellow-300
    Completed: "#86efac", // green-300
  };
  return colors[status] || "#9ca3af";
};

export const getStatusTextColor = (status) => {
  const colors = {
    "In Progress": "#1e3a8a", // blue-900
    "Not Started": "#111827", // gray-900
    Interrupted: "#78350f", // yellow-900
    Completed: "#14532d", // green-900
  };
  return colors[status] || "#111827";
};

export const getPriorityBgColor = (priority) => {
  const colors = {
    "Important and Urgent": "#fca5a5",
    "Important and not Urgent": "#fdba74",
    "Not Important and Urgent": "#fde68a",
    "Not Important and Not Urgent": "#d1d5db",
  };
  return colors[priority] || "#d1d5db";
};

export const getPriorityTextColor = (priority) => {
  const colors = {
    "Important and Urgent": "#7f1d1d",
    "Important and not Urgent": "#7c2d12",
    "Not Important and Urgent": "#78350f",
    "Not Important and Not Urgent": "#1f2937",
  };
  return colors[priority] || "#ffffff";
};

export const statusOptions = [
  "In Progress",
  "Not Started",
  "Interrupted",
  "Completed",
];
export const priorityOptions = [
  "Important and Urgent",
  "Important and not Urgent",
  "Not Important and Urgent",
  "Not Important and Not Urgent",
];

export const LOG_CONFIGS = {
  "secretarial-records": {
    title: "Secretarial Records",
    pageTitle: "UP-Hub Tools - Secretarial Records",
    defaultRow: {
      task: "",
      status: "Not Started",
      secretary: "",
      dateCompleted: "",
      assistedTo: "",
      priority: "Important and Urgent",
      remarks: "",
      subject: "",
    },
    dropdownLists: ["secretaryList", "assistedList"],
    to: {
      salutation: "",
      name: "",
      address: "",
      email: "",
      contact: "",
      rep: "",
      tinNo: "",
    },
  },
  "process-server-logs": {
    title: "Process Server Logs",
    pageTitle: "UP-Hub Tools - Process Server Logs",
    defaultRow: {
      dateCompleted: "",
      task: "",
      status: "Not Started",
      processedBy: "",
      assistedTo: "",
      priority: "Important and Urgent",
      toProcess: "",
      dependencies: "",
      remarks: "",
    },
    dropdownLists: ["processedByList", "assistedList", "agencyList"],
    to: {
      salutation: "",
      name: "",
      address: "",
      email: "",
      contact: "",
      rep: "",
      tinNo: "",
    },
  },
  "exec-admin": {
    title: "Executive & Administrative",
    pageTitle: "UP-Hub Tools - Executive & Administrative",
    defaultRow: {
      dateCompleted: "",
      task: "",
      agency: "",
      status: "Not Started",
      priority: "Important and Urgent",
      remarks: "",
      subject: "",
    },
    dropdownLists: ["processedByList", "assistedList"],
    to: {
      salutation: "",
      name: "",
      address: "",
      email: "",
      contact: "",
      rep: "",
      tinNo: "",
    },
  },
  "case-brief": {
    title: "Case Brief",
    pageTitle: "UP-Hub Tools - Case Brief",
    defaultRow: {
      dateCompleted: "",
      task: "",
      status: "Not Started",
      priority: "Important and Urgent",
      remarks: "",
      subject: "",
    },
    dropdownLists: ["processedByList", "assistedList"],
    to: {
      salutation: "",
      name: "",
      address: "",
      email: "",
      contact: "",
      rep: "",
      tinNo: "",
    },
  },
};
